import templateUrl from './ptoResetDateComponent.html';

class PtoResetDateCtrl {
  constructor(Authentication, sdk) {
    'ngInject';

    const { PTO_FIXED_DATE_TYPE, PTO_HIRE_DATE_TYPE, PTO_RESET_DATE_OPTIONS } = sdk('constants');

    Object.assign(this, {
      Authentication,
      PTO_FIXED_DATE_TYPE,
      PTO_HIRE_DATE_TYPE,
      PTO_RESET_DATE_OPTIONS,
    });
  }

  ptoResetDatePickerOptions = {
    formatDayTitle: 'MMMM',
    maxMode: 'day',
  };
}

export default {
  bindings: {
    leaveResetDate: '=',
    leaveResetType: '=',
  },
  controllerAs: 'ctrl',
  templateUrl,
  controller: PtoResetDateCtrl,
};
